import { UpsellResponse, UpsellInclusionType, InclusionType } from '@shared/flight-itinerary/entities/upsell-flights';

const sortOn = (prop, list) => {
  const order = list.reduce((obj, key, idx) => Object.assign(obj, { [key]: idx + 1 }), {});
  const getVal = item => order[item[prop]] || Infinity;
  return (a, b) => getVal(a) - getVal(b);
};

export function upsellsMapper(upsell: UpsellResponse): UpsellResponse {
  const inclusionTypes: UpsellInclusionType[] = [];
  upsell.UpsellOptions.map(option =>
    option.Families[0].Inclusions.map(inclusion =>
      inclusionTypes.push({ Code: inclusion.Code, Title: inclusion.RowName, Type: inclusion.Type })
    )
  );
  const sortOrder = [InclusionType.Included, InclusionType.AtCharge, InclusionType.NotOffered];
  const uniqueInclusionTypes = [... new Set(inclusionTypes.map(data => data.Code))]
    .map(code => inclusionTypes.find(item => item.Code === code))
    .sort(sortOn('Type', sortOrder));

  return {
    ...upsell,
    UpsellInclusionTypes: uniqueInclusionTypes
  };
}

export function upsellOrderMobile(upsell: UpsellResponse): UpsellResponse {
  const sortOrder = [InclusionType.Included, InclusionType.AtCharge, InclusionType.NotOffered];
  upsell.UpsellOptions.map(options =>
    options.Families.map(family =>
      family.Inclusions.sort(sortOn('Type', sortOrder))
    )
  );
  return upsell;
}

